var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeartView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.775 3C14.1525 3 15.75 5.235 15.75 7.32C15.75 11.5425 9.12 15 9 15C8.88 15 2.25 11.5425 2.25 7.32C2.25 5.235 3.8475 3 6.225 3C7.59 3 8.4825 3.6825 9 4.2825C9.5175 3.6825 10.41 3 11.775 3Z",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartView);
export default __webpack_public_path__ + "static/media/icon_heart_view.2c867d4a122749edc17e55091880c01e.svg";
export { ForwardRef as ReactComponent };